import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

interface SuccessModalProps {
  open: boolean;
  onClose: () => void;
  onContinue: () => void;
}

const SuccessModal: React.FC<SuccessModalProps> = ({
  open,
  onClose,
  onContinue,
}) => {
  

  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        borderRadius: "20px",
        width: "500px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "10vh",
        marginLeft: "auto",
        marginRight: "auto",
      }}
    >
      {" "}
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "center",
          paddingBottom: "20px",
        }}
      >
        <CheckCircleIcon sx={{ color: "#1CA568", fontSize: 114 }} />
      </DialogTitle>
      <DialogContent sx={{ textAlign: "center", paddingX: 10 }}>
        <Typography
          sx={{
            color: "#1CA568",
            fontWeight: 500,
          }}
        >
          We've sent your new credentials to your updated email. Please check
          your email to continue.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", paddingBottom: 3 }}>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#123257",
            color: "white",
            borderRadius: "12px",
            textTransform: "none",
            paddingX: 2,
            paddingY: 1,
          }}
          onClick={onContinue}
        >
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SuccessModal;
